import React from "react";
import { EnumMenuType } from "./Managers/dataStructures";
import { getCurrentUser } from "./Managers/profileManager";
import { getLanguage } from "./Managers/dataProvider";

interface DashboardTopbarProps {
  openProfile: (selectionItem: EnumMenuType) => void;
  signOut: () => void;
  openMenuForMobile: () => void;
  onSearch: (searchTem: string) => void;
  onTopBarMenu: () => void;
  isMenuOpen: boolean;
  isSearchable: boolean;
}

export default function DashboardTopbar(props: DashboardTopbarProps) {
  const isEnglish = getLanguage();
  function openDrawerMenu() {
    props.openMenuForMobile();
  }

  function onMenu() {
    props.onTopBarMenu();
  }

  function openProfile(selectionItem: EnumMenuType) {
    onMenu();
    props.openProfile(selectionItem);
  }

  function signout() {
    onMenu();
    props.signOut();
  }

  function onSearch(value: string) {
    props.onSearch(value);
  }

  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        onClick={openDrawerMenu}
      >
        <span className="sr-only">Open sidebar</span>
        <svg
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </button>

      {/* Separator */}
      <div
        className="h-6 w-px bg-gray-900/10 lg:hidden"
        aria-hidden="true"
      ></div>

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        {props.isSearchable === true ? (
          <form className="relative flex flex-1" action="#" method="GET">
            <label htmlFor="search-field" className="sr-only">
              {isEnglish ? "Search" : "Suche"}
            </label>
            <svg
              className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                //fill-rule="evenodd"
                fillRule="evenodd"
                d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                //clip-rule="evenodd"
                clipRule="evenodd"
              />
            </svg>
            <input
              id="search-field"
              className="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
              placeholder={isEnglish ? "Search..." : "Suche..."}
              type="search"
              name="search"
              onChange={(x) => onSearch(x.currentTarget.value)}
            />
          </form>
        ) : (
          <div className="relative flex flex-1" />
        )}

        <div className="flex items-center gap-x-4 lg:gap-x-6">
          {/* Separator */}
          <div
            className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10"
            aria-hidden="true"
          ></div>
          {/* Profile dropdown */}
          <div className="relative">
            <button
              onClick={onMenu}
              type="button"
              className="-m-1.5 flex items-center p-1.5"
              id="user-menu-button"
              aria-expanded="false"
              aria-haspopup="true"
            >
              <span className="sr-only">Open user menu</span>
              <img
                className="h-8 w-8 rounded-full bg-gray-50"
                src={getCurrentUser().profile_pic_url}
                alt=""
              />
              <span className="hidden lg:flex lg:items-center">
                <div className="mr-2 flex flex-col justify-center">
                  <span
                    className="ml-4 text-sm font-semibold leading-4 text-gray-900"
                    aria-hidden="true"
                  >
                    {getCurrentUser().first_name +
                      " " +
                      getCurrentUser().last_name}
                  </span>
                  <span
                    className="ml-4 text-sm leading-4 text-gray-900"
                    aria-hidden="true"
                  >
                    {getCurrentUser().role.display_name}
                  </span>
                </div>
                <svg
                  className="ml-2 h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    //fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    //clip-rule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            </button>
            {/* Dropdown menu, show/hide based on menu state. Entering:
                    "transition ease-out duration-100" From: "transform opacity-0
                    scale-95" To: "transform opacity-100 scale-100" Leaving:
                    "transition ease-in duration-75" From: "transform opacity-100
                    scale-100" To: "transform opacity-0 scale-95" */}
            {props.isMenuOpen ? MenuList(openProfile, signout) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

function MenuList(
  profileHandler: (selectionItem: EnumMenuType) => void,
  signoutHandler: () => void
) {
  const isEnglish = getLanguage();
  function openProfile() {
    profileHandler(EnumMenuType.USER_DETAIL);
  }

  function changePass() {
    profileHandler(EnumMenuType.CHANGE_PASSWORD_SELF);
  }

  function signOut() {
    signoutHandler();
  }
  return (
    <div
      className="absolute right-0 z-10 mt-2.5 w-42 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="user-menu-button"
      tabIndex={-1}
    >
      {/* Active: "bg-gray-50", Not Active: "" */}
      <a
        onClick={openProfile}
        href="#OpenProfile"
        className="block px-3 py-1 text-sm leading-6 text-gray-900"
        role="menuitem"
        tabIndex={-1}
        id="user-menu-item-0"
        key="profile-item"
      >
        {isEnglish ? "Profile" : "Profil"}
      </a>
      <a
        key="change-passs"
        onClick={changePass}
        href="#77"
        className="block px-3 py-1 text-sm leading-6 text-gray-900"
        role="menuitem"
        tabIndex={-1}
        id="user-menu-item-1"
      >
        {isEnglish ? "Change Password" : "Passwortändern"}
      </a>
      <a
        key="dignout-item"
        onClick={signOut}
        href="#77"
        className="block px-3 py-1 text-sm leading-6 text-gray-900"
        role="menuitem"
        tabIndex={-1}
        id="user-menu-item-1"
      >
        {isEnglish ? "Sign out" : "Abmelden"}
      </a>
    </div>
  );
}
